import { Component, Input, OnInit, ViewChild, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CerrixEditorComponent } from "@app/shared/components/cerrix-editor/cerrix-editor.component";
import { ModuleType } from "@enums/ModuleType";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { injectTranslation } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/mailmessages/i18n/scope";
import { ToastrService } from "ngx-toastr";
import { PeriodicNotificationDetailMoiComponent } from "./pages/moi/periodic-notification-detail-moi.component";
import { PeriodicNotificationDetailIncidentsComponent } from "./pages/incidents/periodic-notification-detail-incidents.component";

@Component({
    selector: "uc-periodic-notification-detail",
    templateUrl: "./periodic-notification-detail.component.html",
    styleUrls: ["./periodic-notification-detail.component.scss"],
    imports: [PeriodicNotificationDetailMoiComponent, PeriodicNotificationDetailIncidentsComponent],
})
export class PeriodicNotificationDetailComponent implements OnInit {
    private _route = inject(ActivatedRoute);
    private toastr = inject(ToastrService);
    private translation = injectTranslation(scope);

    @ViewChild("editor") editorComponent: CerrixEditorComponent;
    module: ModuleType;
    moduleTypes = ModuleType;

    tab: TabModel;
    id: any;

    constructor() {
        this.id = this._route.snapshot.params.id;
    }

    async ngOnInit() {
        // A pipe/directive on this component's own template triggers the scope load, but the
        // @switch below renders no sub-component (and so no pipe) until `module` is set, so an
        // early return here must preload the scope itself before translating.
        await this.translation.ready();

        const config = this.tab.config;
        if (!config) {
            this.toastr.error(this.translation.t("periodicDetail.errorOpeningDetails"));
            this.tab.close(false);
            return;
        }

        this.module = config.module;
    }
}
